// /src/components/Footer.jsx

import React, { useState } from "react";
import { useAuth } from "../authContext";
import { useStatus } from "../StatusContext";
import rsiIcon from "../medias/rsi.png";
import discordIcon from "../medias/discord.png";
import LoadingSpinner from "./LoadingSpinner";
import { Link } from "react-router-dom";
import KoFiModal from "./KoFiModal";
import DonorHeartIcon from "./icons/DonorHeartIcon";

function FooterIconExternal({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
      />
    </svg>
  );
}

function Footer() {
  const { isLoggedIn } = useAuth();
  const status = useStatus();
  const isMaintenance =
    status?.maintenance === true ||
    status?.networkStatus === "offline" ||
    status?.serverStatus === "unreachable";
  const loading = false;
  const [showKoFi, setShowKoFi] = useState(false);
  const canOpenDonateModal = isLoggedIn;

  const maintenanceLock = isMaintenance ? { lockStatus: true } : null;

  const handleDonateClick = () => {
    if (!canOpenDonateModal) return;
    setShowKoFi(true);
  };

  return (
    <div className="footer-root" key={loading ? "footer-spinner" : "footer-content"}>
      {loading ? (
        <LoadingSpinner />
      ) : maintenanceLock?.lockStatus && !isLoggedIn ? null : (
        <footer className="main-footer">
          <div className="footer-content">
            <section className="footer-brand" aria-label="Community">
              <img
                src={`${process.env.STATIC_HOST}/files/rte_images/UploadFiles-1718207733855.png`}
                alt=""
                className="footer-brand__logo"
              />
              <div className="footer-brand__text">
                <p className="footer-brand__tagline">Built by the community</p>
                <p className="footer-brand__since">Since 2020</p>
              </div>
            </section>

            <div className="footer-divider" aria-hidden="true" />

            <section className="footer-legal" aria-label="Legal">
              <nav className="footer-legal__nav" aria-label="Legal pages">
                <Link to="/legal" className="footer-legal__link">
                  Legal Information
                </Link>
                <Link to="/privacy" className="footer-legal__link">
                  Privacy Policy
                </Link>
                <Link to="/gcu" className="footer-legal__link">
                  Terms of Use
                </Link>
                <Link to="/contact" className="footer-legal__link">
                  Contact
                </Link>
              </nav>
              <p className="footer-legal__copyright">
                &copy; {new Date().getFullYear()} PALLAS INVICTUS
              </p>
            </section>

            <div className="footer-divider" aria-hidden="true" />

            <section className="footer-social" aria-label="External links">
              <a
                href="https://robertsspaceindustries.com/orgs/PISC"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social__row"
              >
                <span className="icon-container icon-rsi">
                  <img src={rsiIcon} alt="" className="icon-image" />
                </span>
                <span className="footer-social__label">Roberts Space Industries</span>
                <FooterIconExternal className="footer-social__external" />
              </a>
              <a
                href="https://discord.gg/dXhWQpkM24"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social__row"
              >
                <span className="icon-container icon-discord">
                  <img src={discordIcon} alt="" className="icon-image" />
                </span>
                <span className="footer-social__label">Discord</span>
                <FooterIconExternal className="footer-social__external" />
              </a>
              <button
                type="button"
                className={[
                  'footer-social__row',
                  'footer-social__row--donate',
                  !canOpenDonateModal ? 'footer-social__row--donate--locked' : '',
                ].filter(Boolean).join(' ')}
                onClick={handleDonateClick}
                disabled={!canOpenDonateModal}
                aria-disabled={!canOpenDonateModal}
                title={!canOpenDonateModal ? 'Members only' : undefined}
                data-resource="public.donation-panel"
                data-action={canOpenDonateModal ? 'execute' : 'read'}
                data-route="/api/public/donate-panel"
              >
                <span className="footer-social__icon footer-social__icon--donate">
                  <DonorHeartIcon className="footer-social__heart" />
                </span>
                <span className="footer-social__label">Donate</span>
              </button>
            </section>
          </div>
          {canOpenDonateModal ? (
            <KoFiModal isOpen={showKoFi} onClose={() => setShowKoFi(false)} />
          ) : null}
        </footer>
      )}
    </div>
  );
}

export default Footer;
